module.exports = __webpack_public_path__ + "static/media/arctic-image-header.49830eaa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/arctic-image-header.png
// module id = 265
// module chunks = 0